import { IFilterSelectedSpecialization } from '@/bundles/GroupFilters/interfaces/inputs/IFilterSelectedSpecialization';

// value entries can be legacy plain strings (older saved filter sets stored texts)
export const getSpecializationMultipleSelectFormattedValue = (value: Array<IFilterSelectedSpecialization | string>): string => {
  return value.map(item => typeof item === 'string' ? item : item.text).join(', ');
}
